import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import {user} from '../../../../store/reducers/user';
import {useDispatch, useSelector} from 'react-redux';
import {nextWorkflowStep, workflow} from '../../../../store/reducers/workflow';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import {insertNewAlert} from '../../../../store/reducers/additionalData';
import {RockwoodForm} from './rockwoodForm';
import {getConfig} from '../../../../util/configUtil';
import {WORKFLOW_OPTIONS} from '../../../../util/workflowUtil';

const Rockwood = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const selectedForm = props.selectedHistoryForm;
    const userObject = useSelector(user);

    const [rockwood, setRockwood] = useState({});

    const workflowData = useSelector(workflow);

    // Configs
    const clinicalFrailtyScoreAlertAfter6 = getConfig('clinicalFrailtyScoreAlertAfter6', false);

    const saveEntry = () => {
        if (!_.isEmpty(rockwood)) {
            const getCFS = _.find(rockwood, {name: 'studies.rockwood'});
            if (clinicalFrailtyScoreAlertAfter6) {
                if (Number(getCFS?.value?.scale?.__code) >= 6) {
                    dispatch(insertNewAlert('cfsOver6', props.patient?.__id, props.patient?.patient?.__id, userObject, props.patient?.admission?.consultantEpisodeId));
                } else {
                    dispatch(insertNewAlert('cancelCfsOver6', props.patient?.__id, props.patient?.patient?.__id, userObject, props.patient?.admission?.consultantEpisodeId));
                }
            }
            if (props.onSave) props.onSave(rockwood);
            if (props.onChange) props.onChange(rockwood);
            if (workflowData.type === WORKFLOW_OPTIONS.CLINICAL_FRAILTY_SCORE)
                dispatch(nextWorkflowStep());
        }
        if (props.onClose) props.onClose();
    };

    const checkInvalid = () => {
        if (!_.isEmpty(rockwood)) {
            return !rockwood[0]?.value?.scale;
        }
        return true;
    };

    useEffect(() => {
        if (props.agyleDialogInsertButtons) {
            props.agyleDialogInsertButtons([
                <AgyleButton
                    variant="contained"
                    onClick={saveEntry}
                    disabled={checkInvalid() || props.disableSave}
                    key="cfs-submit"
                >
                    {t('Submit')}
                </AgyleButton>,
            ]);
        }
        if (props.onSubmitFunction) {
            props.onSubmitFunction(saveEntry);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(checkInvalid() || props.disableSave);
        }
    }, [rockwood, props.disableSave]);

    return (
        <RockwoodForm
            patient={props.patient}
            save={setRockwood}
            selectedForm={selectedForm}
            parentForm={props.parentForm}
        />
    );
};

export default Rockwood;

